import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

const LOGO_URL =
    "https://static.prod-images.emergentagent.com/jobs/fb6ef195-8def-42f5-a888-c593b7a86416/images/f55d2dade49c9e024e977c050cea390637d485471432710eb94200fd9ef6e3f8.png";

export function SpeakUpLogo({ size = 28, className = "" }) {
    return (
        <img
            src={LOGO_URL}
            alt="SpeakUp"
            width={size}
            height={size}
            style={{ width: size, height: size, borderRadius: 6 }}
            className={className}
        />
    );
}

export default function Layout({ children, hideHeader = false }) {
    const { consumer } = useAuth();
    const loc = useLocation();
    return (
        <div className="min-h-screen bg-white text-[var(--speakup-text)]">
            {!hideHeader && (
                <header
                    className="sticky top-0 z-30 bg-white/85 backdrop-blur border-b border-[var(--speakup-border)]"
                    data-testid="app-header"
                >
                    <div className="max-w-3xl mx-auto px-5 py-3 flex items-center justify-between">
                        <Link to="/" className="flex items-center gap-2" data-testid="header-logo">
                            <SpeakUpLogo size={26} />
                            <span
                                className="display text-[18px] tracking-tight"
                                style={{ color: "var(--speakup-text-strong)" }}
                            >
                                SpeakUp
                            </span>
                        </Link>
                        <nav className="flex items-center gap-4 text-sm">
                            {consumer && (
                                <Link
                                    to="/account"
                                    className={`hover:text-black ${loc.pathname === "/account" ? "text-black" : "text-[var(--speakup-text-muted)]"}`}
                                    data-testid="header-account-link"
                                >
                                    Account
                                </Link>
                            )}
                        </nav>
                    </div>
                </header>
            )}
            <main className="max-w-3xl mx-auto px-5 py-6 speakup-fade-up">{children}</main>
            <footer className="max-w-3xl mx-auto px-5 py-8 text-xs text-[var(--speakup-text-muted)] flex items-center justify-between gap-4 flex-wrap">
                <span>SpeakUp never sends email to institutions. You send from your own email; we draft, route and track.</span>
                <span className="flex items-center gap-4">
                    <Link to="/landing" className="underline hover:text-[var(--speakup-text-strong)]" data-testid="footer-landing-link">
                        View public homepage
                    </Link>
                    <Link to="/wins" className="underline hover:text-[var(--speakup-text-strong)]" data-testid="footer-wall-of-wins-link">
                        Wall of Wins →
                    </Link>
                </span>
            </footer>
        </div>
    );
}
